import {connect} from "react-redux";
import React, {useCallback, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import {CAlert, CButton, CCol, CForm, CInputGroup, CInputGroupText} from "@coreui/react";
import StoreListWhere from "../../where/StoreListWhere";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import {Br, Cut, Line, Printer, render, Row, Text} from "react-thermal-printer";
import * as saleMethod from "../../../../api/method/saleMethod";
import * as stockMethod from "../../../../api/method/stockMethod";
import * as commonUtil from "../../../../config/common";
import * as api from "../../../../api/api";
import * as o2Api from "../../../../api/api";
import {gridColumnSum} from "../../../../config/common";
import {gridColumnAvg} from "../../../../config/common";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {getErestSimpleStockList, putSaleSpct} from "../../../../api/api";
import {func} from "prop-types";

const ErpSaleReport = (props) => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({visible: false, message: ""});
    const [searchForm, setSearchForm] = useState({saleDt: dayjs(), cmpCd: "", brandCd: ""});

    const defaultColDef = {
        width: 100,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {
            field: "saleDt", headerName: "영업일자", width: 120, valueFormatter: (e) => {
                return formatter.timeFormatter(e, "YYYYMMDD", "YYYY-MM-DD");
            }
        },
        {field: "storeCd", headerName: "매장코드", width: 105},
        {field: "storeNm", headerName: "매장명"},
        {
            field: "file", headerName: "파일", cellStyle: {color: 'blue'}, valueFormatter: () => {
                return "파일"
            }, width: 80
        },
        {
            field: "send", headerName: "전송", cellStyle: {color: 'blue'}, valueFormatter: () => {
                return "전송"
            }, width: 80
        },
        {field: "totalSaleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter},
        {field: "totalDcAmt", headerName: "총할인", valueFormatter: formatter.currencyFormatter},
        {field: "totalPayAmt", headerName: "실매출", valueFormatter: formatter.currencyFormatter},
        {field: "totalBillCnt", headerName: "영수건수", valueFormatter: formatter.currencyFormatter},
        {field: "totalNetAmt", headerName: "가액", valueFormatter: formatter.currencyFormatter},
        {field: "totalVatAmt", headerName: "부가세", valueFormatter: formatter.currencyFormatter},
        {field: "bagPrice", headerName: "봉투", valueFormatter: formatter.currencyFormatter},
        {field: "totalPayAmt", headerName: "결제합계", valueFormatter: formatter.currencyFormatter},
        {field: "cashAmt", headerName: "단순현금", valueFormatter: formatter.currencyFormatter},
        {field: "rctCashAmt", headerName: "현금영수", valueFormatter: formatter.currencyFormatter},
        {field: "cardAmt", headerName: "신용카드", valueFormatter: formatter.currencyFormatter}
    ]);

    const search = () => {
        const {cmpCd, brandCd} = searchForm;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            fromTime: searchForm.saleDt.format("YYYYMMDD"),
            toTime: searchForm.saleDt.format("YYYYMMDD")
        };
        console.log(">>> params :: ", params);

        props.setLoading(true);
        saleMethod.getDailyStoreSaleReport(params).then((result) => {
            console.log(">> result :: ", result);
            setRowData(result);
            createStatTotalRowData(result);
            props.setLoading(false);
        });
    };

    const createStatTotalRowData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            storeNm: "합계",
            file: null,
            send: null,
            totalSaleAmt: gridColumnSum(data, 'totalSaleAmt'),
            totalDcAmt: gridColumnSum(data, 'totalDcAmt'),
            totalPayAmt: gridColumnSum(data, 'totalPayAmt'),
            totalBillCnt: gridColumnSum(data, 'totalBillCnt'),
            totalNetAmt: gridColumnSum(data, 'totalNetAmt'),
            totalVatAmt: gridColumnSum(data, 'totalVatAmt'),
            bagPrice: gridColumnSum(data, 'bagPrice'),
            totalPay: gridColumnSum(data, 'totalPay'),
            cashAmt: gridColumnSum(data, 'cashAmt'),
            rctCashAmt: gridColumnSum(data, 'rctCashAmt'),
            cardAmt: gridColumnSum(data, 'cardAmt')
        });
        api.setPinnedBottomRowData(result);
    };

    const file = (data) => {
        const params = {
            stockDt: data.saleDt,
            storeCd: data.storeCd,
            brandCd: data.brandCd,
            type: "1"
        };

        props.setLoading(true);
        stockMethod.getErestSimpleStockList(params).then((result) => {
            props.setLoading(false);

            console.log("### result :: ", result)
            const erpData = Object.values(
                result.reduce((acc, item) => {
                    const key = `${item.erpCd}_${item.cornerCd}`;

                    // 그룹 초기화
                    if (!acc[key]) {
                        acc[key] = {
                            erpCd: item.erpCd,
                            cornerCd: item.cornerCd,
                            data: []
                        };
                    }
                    // 현재 항목을 그룹에 추가
                    acc[key].data.push(item);

                    return acc;
                }, {})
            )
            exportTxt(data, erpData)
        });
    }

    const exportTxt = (row, data) => {
        data.map((item) => {
            const erpCode = item.erpCd;

            let fileName = erpCode + row.storeCd + dayjs().format("YYYYMMDD") + '.txt';
            let output = "";
            item.data.map((item2) => {
                output += item2.restProductCd +
                    commonUtil.lpad(item2.yesterdayStockCurrentQty, 7, "0") +
                    commonUtil.lpad(item2.todayStockInQty, 7, "0") +
                    commonUtil.lpad(item2.todayStockSaleQty, 7, "0") + "\n"
            })
            const element = document.createElement('a');
            const file = new Blob([output], {
                type: 'text/plain',
            });
            element.href = URL.createObjectURL(file);
            element.download = fileName;
            document.body.appendChild(element);
            element.click();

        });
    }

    const sendTotal = async () => {
        const {api, columnApi} = gridRef.current;
        if (api === null) return;

        let saleSpct = [];
        if (confirm("전체 데이터를 일괄 전송합니다. 계속 하시겠습니까?")) {
            // 전체 데이터 가져오기
            let rowData = [];
            api.forEachNode(node => rowData.push(node.data));

            props.setLoading(true);
            // 전송용 데이터 세팅
            for (const row of rowData) {
                const params = {
                    stockDt: row.saleDt,
                    storeCd: row.storeCd,
                    brandCd: row.brandCd,
                    type: "1"
                }

                const response = await getErestSimpleStockList(params);
                response.data.responseBody.map((item) => {
                    const body = {
                        spctDate: row.saleDt,
                        spctDdiqty: item.todayStockInQty - item.todayStockOutQty,
                        spctDdpqty: item.todayStockSaleQty,
                        spctDept: item.erpCd,
                        spctItem: item.restProductCd,
                        spctJdjqty: item.yesterdayStockCurrentQty
                    }
                    saleSpct.push(body);
                });
            }

            // 전송
            o2Api.putSaleSpct(saleSpct).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                props.setLoading(false);
                if (responseCode === "200") {
                    // 성공
                    alert("전송이 완료되었습니다.");
                } else {
                    alert("전송에 실패했습니다.\n잠시 후 다시 시도해주세요.");
                }
            });
        }
    }

    const send = (data) => {
        const params = {
            stockDt: data.saleDt,
            storeCd: data.storeCd,
            brandCd: data.brandCd,
            type: "1"
        };

        props.setLoading(true);
        stockMethod.getErestSimpleStockList(params).then((result) => {
            const saleSpct = [];
            result.map((item) => {
                const body = {
                    spctDate: data.saleDt,
                    spctDdiqty: item.todayStockInQty - item.todayStockOutQty,
                    spctDdpqty: item.todayStockSaleQty,
                    spctDept: item.erpCd,
                    spctItem: item.restProductCd,
                    spctJdjqty: item.yesterdayStockCurrentQty
                }
                saleSpct.push(body);
            });

            o2Api.putSaleSpct(saleSpct).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                props.setLoading(false);
                if (responseCode === "200") {
                    // 성공
                    alert("전송이 완료되었습니다.");
                } else {
                    alert("전송에 실패했습니다.\n잠시 후 다시 시도해주세요.");
                }
            });
        });
    }

    const onCellClicked = useCallback((event) => {
        const def = event.colDef.field;
        if (def === "file") {
            file(event.node.data);
        } else if (def === "send") {
            send(event.node.data);
        }
    }, []);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    };

    return (
        <>
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>ERP 자료</h5>
                <div>
                    <CButton style={{marginRight: 5}} color="primary" onClick={sendTotal}>전송</CButton>
                    <CButton color="primary" onClick={search}>조회</CButton>
                </div>
            </div>
            <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                <StoreCornerListWhere type={"B"} account={props.account} selected={searchForm}
                                      onSelect={(c, v) => handleSelect(c, v)}/>
                <CCol xs={12}>
                    <CInputGroup size={"sm"}>
                        <CInputGroupText style={{width: 80}}>영업일자</CInputGroupText>
                        <CInputGroupText style={{background: "white", height: 35}}>
                            <DatePicker bordered={false}
                                        placeholder={""}
                                        locale={locale}
                                        value={searchForm.saleDt}
                                        onChange={(dayjs, dateString) => {
                                            setSearchForm((state) => ({
                                                ...state, saleDt: dayjs
                                            }));
                                        }}/>
                        </CInputGroupText>
                    </CInputGroup>
                </CCol>
            </CForm>
            <div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    onCellClicked={onCellClicked}
                    animateRows={true}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ErpSaleReport);
